import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "../../context/I18nContext";
import "./StudentShell.css";

export default function StudentShell({ children }) {
  const { logout } = useAuth();
  const { t, language, setLanguage, languages } = useTranslation();
  const languageNames = {
    fr: "Français",
    en: "English",
    ar: "العربية",
    de: "Deutsch",
    it: "Italiano",
    es: "Español",
  };
  const location = useLocation();

  const isActive = (path) => {
    if (!path) return false;
    if (path === "/dashboard") return location.pathname === "/dashboard";
    return location.pathname.startsWith(path);
  };

  return (
    <div className="student-shell">
      <div className="student-shell__layout">
        <aside
          className="student-shell__rail"
          aria-label={t("studentShell.shortcutsLabel")}
        >
          <div className="student-shell__railBrand">
            <Link className="student-shell__railLogo" to="/dashboard">
              C
            </Link>
          </div>

          <nav
            className="student-shell__railIcons"
            aria-label={t("studentShell.mainNavLabel")}
          >
            <Link
              className={`student-shell__railLink ${
                isActive("/dashboard") ? "is-active" : ""
              }`}
              to="/dashboard"
              aria-label={t("sidebar.links.dashboard")}
              title={t("sidebar.links.dashboard")}
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
            </Link>
            <Link
              className={`student-shell__railLink ${
                isActive("/lessons") ? "is-active" : ""
              }`}
              to="/lessons?view=timetable"
              aria-label={t("sidebar.links.lessons")}
              title={t("sidebar.links.lessons")}
            >
              <i className="fa-solid fa-calendar-days" aria-hidden="true" />
            </Link>
            <Link
              className={`student-shell__railLink ${
                isActive("/resources") ? "is-active" : ""
              }`}
              to="/resources"
              aria-label={t("sidebar.links.resources")}
              title={t("sidebar.links.resources")}
            >
              <i className="fa-solid fa-folder-open" aria-hidden="true" />
            </Link>
            <Link
              className={`student-shell__railLink ${
                isActive("/homeworks") ? "is-active" : ""
              }`}
              to="/homeworks"
              aria-label={t("sidebar.links.homeworks", { defaultValue: "Homework" })}
              title={t("sidebar.links.homeworks", { defaultValue: "Homework" })}
            >
              <i className="fa-solid fa-book" aria-hidden="true" />
            </Link>
          </nav>

          <div className="student-shell__railBottom">
            {/* Language: globe icon over an invisible native select, so phones
                open their own picker. */}
            <label
              className="student-shell__railLink student-shell__lang"
              title={languageNames[language] || language}
            >
              <i className="fa-solid fa-globe" aria-hidden="true" />
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                aria-label={t("nav.language", { defaultValue: "Language" })}
              >
                {(languages || []).map((code) => (
                  <option key={code} value={code}>
                    {languageNames[code] || code}
                  </option>
                ))}
              </select>
            </label>
            <Link
              className={`student-shell__railLink ${
                isActive("/profile") ? "is-active" : ""
              }`}
              to="/profile"
              aria-label={t("sidebar.links.profile")}
              title={t("sidebar.links.profile")}
            >
              <i className="fa-solid fa-user" aria-hidden="true" />
            </Link>
            <button
              type="button"
              className="student-shell__railLink"
              onClick={logout}
              aria-label={t("sidebar.logout")}
              title={t("sidebar.logout")}
            >
              <i
                className="fa-solid fa-right-from-bracket"
                aria-hidden="true"
              />
            </button>
          </div>
        </aside>

        <main className="student-shell__main">{children}</main>
      </div>
    </div>
  );
}
